export function shList () {
  const showMore = document.querySelectorAll('[data-showmore-cont]');

  [].forEach.call(showMore, showMoreContainer => {
    const button = showMoreContainer.querySelector('[data-showmore-btn]');
    const count = showMoreContainer.getAttribute('data-showmore-cont');
    const elements = showMoreContainer.querySelectorAll('[data-showmore-element]');

    if (elements.length > count) {
      button.classList.remove('opacity-0');
    }

    [].forEach.call(elements, (el, i) => {
      if (i >= count){
        if (i == count){
          showMoreContainer.insertBefore(button, el);
        }
        el.classList.add('is-hidden');
      }
    })


    button.addEventListener('click', function () {
      this.classList.add('opacity-0');
      [].forEach.call(elements, el => {
        el.classList.remove('is-hidden');
      })
    });
  })
}
